if(!customElements.get('cart-announcement')) {
  class CartAnnouncement extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    deleteSelf(){
      this.remove();
    }

    init(){
      // console.log("CartAnnouncement init()");
      this.spinner = this.querySelector('.loading-overlay__spinner');
      const scriptTag = this.querySelector('script[type="application/json"]:first-of-type');
      this.settings = (scriptTag)? JSON.parse(scriptTag.textContent) : {};
      // scrub the original script tag from the DOM, now we are storing it's contents as component data.
      if(scriptTag) this.removeChild(scriptTag);
      // console.log("CartAnnouncement settings ", this.settings);
      // console.log(`CartAnnouncement settings JSON ${JSON.stringify(this.settings)}`);
      this.cartSubtotal = this.settings.cart_inclusions_subtotal;
      // console.log(`Cart subtotal (not counting exclusions): ${Shopify.formatMoney((this.cartSubtotal), '${{amount}}')}`);
      this.renderAnnouncementContent();
    }

    renderAnnouncementContent() {
      // Helper function to format a discount as either a percentage or money value.
      const formatDiscount = (amount, type) => {
        return type === 'percentage' ? `${amount}%` : Shopify.formatMoney(amount, '${{amount_no_decimals}}');
      };

      // Helper function to calculate the difference needed to reach a threshold.
      const calculateDifference = (threshold) => {
        return Math.max(threshold - this.cartSubtotal, 0);
      };

      // Helper function to sort tiers by threshold from lowest to highest
      const sortTiersByThreshold = (tiers) => {
        return tiers.sort((a, b) => a.threshold - b.threshold);
      };

      // Helper function to find the highest tier the cart subtotal is greater than, since we order tiers by threshold value, we will start in reverse.
      // The first tier we have a greater value than, is the highest applicable tier.
      const findCurrentTierIndex = (sortedTiers, subtotal) => {
        let index = -1;
        for (let i = sortedTiers.length - 1; i >= 0; i--) {
          if (subtotal >= sortedTiers[i].threshold) {
            index = i;
            break;
          }
        }
        return index;
      };

      let content = '';

      // Check for free_shipping settings and render content
      if (this.settings.free_shipping) {
        /*
          If we have "free shipping" we are in "earn free shipping" mode.
          Take the cart subtotal (not counting exclusions), and compare that value to the value stored in the settings.
          If we have reached free shipping show the met message.
          Otherwise, show the "not met" message and calculate the spend needed to meet the goal.
        */
        const threshold = parseInt(this.settings.free_shipping.threshold, 10);
        const difference = calculateDifference(threshold);
        if (difference > 0) {
          // Replace {threshold} with the formatted money difference
          content = this.settings.free_shipping.strings.free_shipping_threshold_not_met.replace('{threshold}', formatDiscount(difference, "money"));
        } else {
          content = this.settings.free_shipping.strings.free_shipping_threshold_met;
        }
      } else if (this.settings.buy_more_save_more) {
        /*
          If we have "buy more save more" then we are in "rewards tier" mode. order the tiers from lowest threshold to highest.
          Find the highest tier we have reached at the moment.
          If we have no tier we have reached show our default.
          If we have reached a tier, but we have more we could go, render a BMSM met message.
          If we have reached as high as we can go, show the BMSM maximum messaging.
        */
        const tiers = sortTiersByThreshold(this.settings.buy_more_save_more.tiers);
        const currentTierIndex = findCurrentTierIndex(tiers, this.cartSubtotal);
        const currentTier = tiers[currentTierIndex];
        const nextTier = tiers[currentTierIndex + 1];
        // console.log(`tiers: `, tiers);
        // console.log(`currentTier: `, currentTier);
        // console.log(`nextTier: `, nextTier);
        if (currentTierIndex === -1) {
          // No tiers met yet
          const firstTier = tiers[0];
          content = this.settings.buy_more_save_more.strings.buy_more_save_more_initial.replace('{discount}', formatDiscount(firstTier.discount, firstTier.discount_type)).replace('{thresholdTier}', formatDiscount(firstTier.threshold, 'amount_off'));
        } else if (!nextTier) {
          // Maximum tier met
          content = this.settings.buy_more_save_more.strings.buy_more_save_more_maximum.replace('{currentDiscount}', formatDiscount(currentTier.discount, currentTier.discount_type));
        } else {
          // A tier has been met, but not the maximum
          const differenceToNextTier = calculateDifference(nextTier.threshold);
          content = this.settings.buy_more_save_more.strings.buy_more_save_more_met.replace('{currentDiscount}', formatDiscount(currentTier.discount, currentTier.discount_type)).replace('{target}', formatDiscount(differenceToNextTier, 'amount_off')).replace('{nextDiscount}', formatDiscount(nextTier.discount, nextTier.discount_type));
        }
      } else {
        // if we have reached this branch then we have no data for free shipping or buy more save more.
        // delete the element.
        this.deleteSelf();
        return false;
      }
      this.innerHTML = content; // Render the content inside the component
      return true;
    }

  }

  customElements.define('cart-announcement', CartAnnouncement);
}
